import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { toast } from '@/hooks/use-toast';
import { ThumbsUp } from 'lucide-react';
import { saveFlavorVote, getFlavorVotes } from '@/lib/supabaseClient';
const flavors = [{
  name: 'Açaí',
  color: 'bg-floresta-acai',
  id: 'acai'
}, {
  name: 'Chocolate',
  color: 'bg-amber-800',
  id: 'chocolate'
}, {
  name: 'Morango',
  color: 'bg-red-400',
  id: 'morango'
}, {
  name: 'Pistache',
  color: 'bg-green-300',
  id: 'pistache'
}, {
  name: 'Cupuaçu',
  color: 'bg-floresta-caramel',
  id: 'cupuacu'
}, {
  name: 'Coco',
  color: 'bg-gray-100',
  id: 'coco'
}];
const FlavorGallery = () => {
  const [flavorVotes, setFlavorVotes] = useState<Record<string, number>>({});
  const [hasVoted, setHasVoted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Buscar contagem atual de votos ao carregar
    const fetchVotes = async () => {
      setIsLoading(true);
      const voteCounts = await getFlavorVotes();
      setFlavorVotes(voteCounts);
      setIsLoading(false);
    };
    fetchVotes();
  }, []);
  const handleVote = async (flavorId: string) => {
    // Atualizar UI imediatamente para feedback visual
    setFlavorVotes(prev => ({
      ...prev,
      [flavorId]: (prev[flavorId] || 0) + 1
    }));

    // Persistir voto no Supabase
    await saveFlavorVote(flavorId);

    // Mostrar toast apenas para o primeiro voto
    if (!hasVoted) {
      toast({
        title: "Obrigado pelo seu voto!",
        description: "Você pode votar em quantos sabores quiser, quantas vezes quiser.",
        duration: 3000
      });
      setHasVoted(true);
    }
  };
  return <section className="py-16 px-4 bg-gradient-to-b from-white to-floresta-pistachio/20">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-floresta-acaiDark text-center mb-4">
          Sabores que encantam
        </h2>
        <p className="text-lg md:text-xl text-center mb-4 max-w-2xl mx-auto">Tudo feito com carinho.</p>
        <p className="text-md text-center mb-12 max-w-2xl mx-auto text-floresta-acaiDark font-bold">
          Clique nos sabores que você mais gosta!
        </p>
        
        {isLoading ? <div className="text-center py-12">Carregando votos...</div> : <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {flavors.map(flavor => <div key={flavor.id} className="group">
                <div className={`relative ${flavor.color} rounded-xl overflow-hidden aspect-square shadow-lg hover:shadow-xl transition-all duration-300 group-hover:scale-[1.02] cursor-pointer`} onClick={() => handleVote(flavor.id)}>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-4">
                    <h3 className="text-xl md:text-2xl font-bold text-white">{flavor.name}</h3>
                  </div>
                  
                  {/* Vote counter */}
                  <div className="absolute top-2 right-2 bg-white/80 rounded-full px-2 py-1 flex items-center gap-1">
                    <ThumbsUp size={16} className="text-floresta-acaiDark" />
                    <span className="font-bold text-sm text-floresta-acaiDark">{flavorVotes[flavor.id] || 0}</span>
                  </div>
                  
                  {/* Decorative elements */}
                  <div className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-12 right-8 w-4 h-4 rounded-full bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
              </div>)}
          </div>}
        
        <div className="mt-12 text-center">
          <Button variant="outline" className="bg-floresta-acai/10 border-floresta-acai text-floresta-acaiDark hover:bg-floresta-acai/20" onClick={() => {
          toast({
            title: "Obrigado por votar!",
            description: "Estamos levando seus gostos em consideração para nossa inauguração.",
            duration: 3000
          });
        }}>
            <ThumbsUp size={18} className="mr-2" />
            Registrar meus votos
          </Button>
        </div>
      </div>
    </section>;
};
export default FlavorGallery;